import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-row items-center gap-4 max-w-full" }
const _hoisted_2 = { class: "flex-1 text-left text-sm font-semibold text-wrap break-words overflow-hidden text-ellipsis whitespace-nowrap max-h-full" }
const _hoisted_3 = { class: "flex-1 block space-y-1" }

import Card from '@/components/ui/card/Card.vue';
import { PartnerProvider } from '@/http/partnerProvider';
import { set } from '@vueuse/core';
import { PropType, computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import ProviderIcon from '@/components/ProviderIcon.vue';
import { CustomerSession, getSessions } from '@/http/customerSession';
import { useStore } from 'vuex';
import { GET_CREDENTIALS, PARTNER_ID } from '@/store';
import StatQuery from '@/components/dashboard/StatQuery.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerProviderStats',
  props: {
  partnerProvider: {
    type: Object as PropType<PartnerProvider>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { getters } = useStore();

const router = useRouter();

const waiting = ref(0);
const expired = ref(0);
const finished = ref(0);
const total = computed(() => waiting.value + finished.value + expired.value);

const queried = ref(false);

const filterExpired = (sessions: CustomerSession[]) => {
  return sessions.filter((session: CustomerSession) => session.expirationDate < new Date());
};
onMounted(async () => {
  const finishedSessions = await getSessions({
    size: 10000000,
    page: 0,
    partnerProviderId: props.partnerProvider.id,
    considerTimeout: false,
    partnerId: getters[PARTNER_ID],
    status: 'FINISHED',
  }, getters[GET_CREDENTIALS]);
  set(finished, finishedSessions.content.length);

  const waitingSessions = await getSessions({
    size: 10000000,
    page: 0,
    partnerProviderId: props.partnerProvider.id,
    considerTimeout: false,
    partnerId: getters[PARTNER_ID],
    status: 'OPEN_SUPPORT',
  }, getters[GET_CREDENTIALS]);
  set(waiting, waitingSessions.content.length);

  const expiredOpenSupport = await getSessions({
    size: 10000000,
    page: 0,
    partnerProviderId: props.partnerProvider.id,
    considerTimeout: false,
    partnerId: getters[PARTNER_ID],
    status: 'OPEN_SUPPORT',
  }, getters[GET_CREDENTIALS]);
  const expiredOpenBot = await getSessions({
    size: 10000000,
    page: 0,
    partnerProviderId: props.partnerProvider.id,
    considerTimeout: false,
    partnerId: getters[PARTNER_ID],
    status: 'OPEN_BOT',
  }, getters[GET_CREDENTIALS]);
  set(expired, filterExpired(expiredOpenSupport.content).length + filterExpired(expiredOpenBot.content).length);

  set(queried, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    onClick: _cache[0] || (_cache[0] = () => _unref(router).push({ path: `/dashboard/atendimento` })),
    class: "cursor-pointer p-6 min-h-40 w-48 space-y-4 flex flex-col flex-nowrap items-stretch border-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ProviderIcon, {
          provider: __props.partnerProvider.partnerProviderType
        }, null, 8, ["provider"]),
        _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.partnerProvider.presentationNameInProvider), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(StatQuery, {
          stat: 'Em atendimento',
          value: waiting.value,
          "did-query": queried.value
        }, null, 8, ["value", "did-query"]),
        _createVNode(StatQuery, {
          stat: 'Expiradas',
          value: expired.value,
          "did-query": queried.value
        }, null, 8, ["value", "did-query"]),
        _createVNode(StatQuery, {
          stat: 'Finalizadas',
          value: finished.value,
          "did-query": queried.value
        }, null, 8, ["value", "did-query"]),
        _createVNode(StatQuery, {
          stat: 'Total',
          value: total.value,
          "did-query": queried.value
        }, null, 8, ["value", "did-query"])
      ])
    ]),
    _: 1
  }))
}
}

})